import { useContext, useEffect, useState } from "react";
import axiosClient from "../../api/api";
import "/node_modules/flag-icons/css/flag-icons.min.css";
import Header from "../Header/Header";
import PlayerStore from "../../hooks/PlayerStore";
import { UserContext } from "../../hooks/UserStore";

const Preferences = () => {
  const [languages, setLanguages] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const user = useContext(UserContext);

  useEffect(() => {
    fetchLanguages();
  }, []);

  const fetchLanguages = async () => {
    try {
      const response = await axiosClient.get("/track/languages");
      if (response.status === 200) {
        setLanguages(response.data.languages);
        if (response.data.languages.length > 0) {
          setSelectedLanguage(response.data.current);
        }
      }
    } catch (error) {
      setError("Failed to load languages. Please try again later.");
    } finally {
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  const handleLanguageChange = async (lang) => {
    try {
      await axiosClient.post("/track/language/set", { targetLang: lang.code });
      setSelectedLanguage(lang.code);
      user.fetchUser();
    } catch (error) {
      setError("Failed to update language preference. Please try again later.");
    }
  };

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center mt-5">
        <div className="spinner-border text-light" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  const selectedLang =
    languages.find((lang) => lang.code === selectedLanguage) || languages[0];

  return (
    <>
      <PlayerStore>
        <Header />
        <div className="container mt-5 preferences-container">
          <div className="row justify-content-center">
            <div className="col-md-6">
              <div className="card">
                <div className="card-body">
                  {/* <h2 className="card-title mb-4">Language Preferences</h2> */}

                  {error && (
                    <div className="alert alert-danger" role="alert">
                      {error}
                    </div>
                  )}

                  <div className="mb-4">
                    <label className="form-label">
                      Select your target language
                    </label>
                    <div className="dropdown">
                      <button
                        className="btn btn-light btn-lg dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <span>
                          <span
                            className={`fi fi-${selectedLang.flag} me-2`}
                          ></span>
                          {selectedLang.name}
                        </span>
                        <span className="caret"></span>
                      </button>
                      <ul className="dropdown-menu w-100">
                        {languages
                          .sort((a, b) => a.name.localeCompare(b.name))
                          .map((lang) => (
                            <li key={lang.code}>
                              <button
                                className={`dropdown-item d-flex align-items-center ${
                                  lang.code === selectedLanguage ? "active" : ""
                                }`}
                                onClick={() => handleLanguageChange(lang)}
                              >
                                <span
                                  className={`fi fi-${lang.flag} me-2`}
                                ></span>
                                {lang.name}
                              </button>
                            </li>
                          ))}
                      </ul>
                    </div>
                  </div>

                  <div
                    className="alert alert-info text-center mb-0"
                    role="alert"
                  >
                    <i className="bi bi-info-circle me-2"></i>
                    Note: Switching languages often impacts your monthly
                    translation limit.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PlayerStore>
    </>
  );
};

export default Preferences;
